// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qqu_","title":"styles_title__2t6s4"};